import { CompanyDetails } from '@/types/companies';
import { Card, Stack, Typography } from '@mui/material';
import { SVLink } from '@/components/core';
import { ROUTES } from '@/constants/routes';
import { useGetUser } from '@/hooks/requests/useUser';

type CompanyDetailsViewProps = {
  companyDetails: CompanyDetails;
};

export default function CompanyDetailsView({
  companyDetails,
}: CompanyDetailsViewProps) {
  const { canSeeTeammates } = useGetUser();
  const { uuid, aggNumbers } = companyDetails;

  return (
    <Card variant="fullHeight">
      <Typography variant="h5" mb={2}>
        View
      </Typography>
      <Stack spacing={2}>
        {canSeeTeammates && (
          <SVLink to={`${ROUTES.TEAMMATES}?company_id=${uuid}`}>
            Teammates ({aggNumbers.teammates})
          </SVLink>
        )}
        <SVLink to={`${ROUTES.CUSTOMERS}?company_id=${uuid}`}>
          Customers ({aggNumbers.customers})
        </SVLink>
        <SVLink to={`${ROUTES.BUSINESSES}?company_id=${uuid}`}>
          Businesses ({aggNumbers.businesses})
        </SVLink>
        <SVLink to={`${ROUTES.BANK_ACCOUNTS}?company_id=${uuid}`}>
          Active Bank Accounts ({aggNumbers.bankAccounts})
        </SVLink>
        <SVLink to={ROUTES.BANK_ACCOUNT_APPLICATIONS}>
          Draft Bank Applications ({aggNumbers.draftBankApplications})
        </SVLink>
      </Stack>
    </Card>
  );
}
